import { TimeDigits } from '@/shared/constants/types'
import { useEffect, useState } from 'react'
import { useStyles } from './styles'

export const TimeDigit = ({ digit }: { digit: string }) => {
  const { classes } = useStyles()
  const [currentNumber, setCurrentNumber] = useState(digit)
  const [nextNumber, setNextNumber] = useState(digit)
  const [isAnimating, setIsAnimating] = useState(false)

  useEffect(() => {
    if (digit !== currentNumber) {
      setIsAnimating(true)
      setNextNumber(digit)

      const timer = setTimeout(() => {
        setCurrentNumber(digit)
        setIsAnimating(false)
      }, 500)

      return () => clearTimeout(timer)
    }
  }, [digit, currentNumber])

  return (
    <div
      className={classes.digitContainer}
      key={currentNumber}
    >
      <div className={`${classes.digit} ${isAnimating ? classes.animatingCurrentNumber : classes.currentNumber}`}>
        {currentNumber}
      </div>
      <div className={`${classes.digit} ${isAnimating ? classes.animatingNextNumber : classes.nextNumber}`}>
        {nextNumber}
      </div>
    </div>
  )
}

export const TimeDisplay = (props: { timeLeft: TimeDigits }) => {
  const { classes } = useStyles()
  const { timeLeft } = props

  return (
    <div className={classes.container}>
      <TimeDigit digit={timeLeft.hours[0]} />
      <TimeDigit digit={timeLeft.hours[1]} />

      <div className={classes.separator}>:</div>

      <TimeDigit digit={timeLeft.minutes[0]} />
      <TimeDigit digit={timeLeft.minutes[1]} />

      <div className={classes.separator}>:</div>

      <TimeDigit digit={timeLeft.seconds[0]} />
      <TimeDigit digit={timeLeft.seconds[1]} />
    </div>
  )
}
